// ── Cronômetro: store compartilhado + controles na tela de bloqueio ──────────
// O estado do cronômetro vive aqui, num módulo (singleton). O CicloAtivo publica
// o estado; o cronômetro flutuante (em qualquer aba) só lê e manda comandos.
// Como é import ES, há UMA instância só — por isso o timer continua entre abas.
import { useState, useEffect } from "react";
import { loadLS } from "./storage";

// ── Controles na tela de bloqueio (Media Session) ────────────────────────────
// Um áudio silencioso em loop faz o celular mostrar o "player" na tela de bloqueio, com título, tempo e pausar/continuar.
const lockScr = { audio: null };
export const lockEnabled = () => { try { return !!loadLS("sf_lockCtl", false) && typeof navigator !== "undefined" && "mediaSession" in navigator && typeof Audio !== "undefined"; } catch { return false; } };
function lockAudio(durSec) {
  // Áudio silencioso com a MESMA duração do bloco: o iPhone/Android mostram tempo decorrido/total reais e avançam sozinhos.
  const dur = Math.max(2, Math.round(durSec || 2));
  if (lockScr.audio && lockScr.dur === dur) return lockScr.audio;
  const sr = 1000, n = sr * dur, buf = new ArrayBuffer(44 + n), v = new DataView(buf);
  const wr = (o, str) => { for (let i = 0; i < str.length; i++) v.setUint8(o + i, str.charCodeAt(i)); };
  wr(0, "RIFF"); v.setUint32(4, 36 + n, true); wr(8, "WAVE"); wr(12, "fmt "); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, sr, true); v.setUint32(28, sr, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true); wr(36, "data"); v.setUint32(40, n, true);
  new Uint8Array(buf, 44).fill(128);                                        // 8 bits sem sinal: 128 = silêncio
  const a = lockScr.audio || new Audio();
  if (lockScr.url) { try { URL.revokeObjectURL(lockScr.url); } catch {} }
  lockScr.url = URL.createObjectURL(new Blob([buf], { type: "audio/wav" }));
  a.src = lockScr.url; a.loop = false; a.preload = "auto";
  lockScr.audio = a; lockScr.dur = dur;
  return a;
}
export function lockPrime(durSec) {                                                      // chamar dentro de um clique do usuário
  if (!lockEnabled()) return;
  try { const p = lockAudio(durSec || lockScr.dur || 2).play(); if (p && p.catch) p.catch(() => {}); } catch {}
}
export function lockSet({ running, title, artist, duration, position }) {
  if (!lockEnabled()) return;
  try {
    const ms = navigator.mediaSession;
    ms.metadata = new MediaMetadata({ title, artist, album: "Cronômetro de estudo", artwork: [{ src: `${process.env.PUBLIC_URL || ""}/logo512.png`, sizes: "512x512", type: "image/png" }] });
    ms.playbackState = running ? "playing" : "paused";
    ms.setActionHandler("play",  () => { if (timerStore.state && !timerStore.state.running && timerStore.toggle) timerStore.toggle(); });
    ms.setActionHandler("pause", () => { if (timerStore.state && timerStore.state.running && timerStore.toggle) timerStore.toggle(); });
    if (ms.setPositionState) { const d = Math.max(1, duration); ms.setPositionState({ duration: d, position: Math.min(Math.max(0, position), d), playbackRate: 1 }); }
    const a = lockAudio(duration);
    const pos = Math.min(Math.max(0, position), Math.max(1, duration) - 1);
    if (Math.abs((a.currentTime || 0) - pos) > 1.5) { try { a.currentTime = pos; } catch {} }
    if (running) { const p = a.play(); if (p && p.catch) p.catch(() => {}); } else a.pause();
  } catch {}
}
export function lockStop() {
  try {
    if (lockScr.audio) lockScr.audio.pause();
    if ("mediaSession" in navigator) { navigator.mediaSession.metadata = null; navigator.mediaSession.playbackState = "none"; }
  } catch {}
}

// ── Cronômetro flutuante ─────────────────────────────────────────────────────
export const timerStore = { state: null, toggle: null, dismiss: null, subs: new Set() };
export function publishTimer(state, toggle, dismiss) {
  timerStore.state = state; timerStore.toggle = toggle; timerStore.dismiss = dismiss;
  timerStore.subs.forEach(fn => fn());
}
export function useTimerStore() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force(x => x + 1);
    timerStore.subs.add(fn);
    return () => { timerStore.subs.delete(fn); };
  }, []);
  return timerStore.state;
}
